var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"whitespace-nowrap pt-0 pr-4 pb-0 pl-10 text-xl font-bold border-b border-gray-200 title"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }